import React, { useEffect, useState } from "react";
import { Button, Label } from "reactstrap";

import style from "./CustomDropdown.module.scss";

const CustomDropdown = ({
  items = [],
  getSelectedId = (i) => i,
  getSelectedName = (i) => i,
  getFilterCondition = (i) => i,
  changedColor = false,
  label,
  value,
  onChange,
  name,
  error,
  disabled,
  extendInfo = false,
}) => {
  const searchItemByValue = (valueParam) => items.find((item) => getSelectedId(item) === valueParam);

  const [show, setShow] = useState(false);

  const [search, setSearch] = useState("");
  const [itemsFiltered, setItemsFiltered] = useState([]);

  const selectedItem = items && searchItemByValue(value);
  const selectedItemPreview = selectedItem && getSelectedName(selectedItem);

  useEffect(() => {
    if (search === "") {
      setItemsFiltered(items);
    } else {
      const newItems = items.filter((item) => {
        const itemQuery = getFilterCondition(item);
        return itemQuery.toLowerCase().includes(search.toLowerCase());
      });
      setItemsFiltered(newItems);
    }
  }, [search]);

  useEffect(() => {
    setItemsFiltered(items);
  }, [items]);

  const handleSelect = (item) => {
    onChange(name, getSelectedId(item), getSelectedName(item));
    setShow(() => false);
    setSearch(() => "");
  };

  const renderSelectedName = () => {
  if (!selectedItemPreview) return "";
  if (extendInfo) return selectedItemPreview.length > 80 ? selectedItemPreview.slice(0, 75) + "..."
    : selectedItemPreview;
  return selectedItemPreview.length > 20
    ? selectedItemPreview.slice(0, 25) + "..."
    : selectedItemPreview;
};

  const handleToggle = () => setShow(!show);

  return (
    <div className={style.dropdown}>
      <Label
        style={{
          fontWeight: 500,
          fontSize: "15px",
          display: "block",
          color: changedColor ? "#36a9e1" : "black",
        }}
      >
        {label}
      </Label>
      <Button
        className={`${style.dropbtn} ${selectedItemPreview ? style.withPreview : style.withoutPreview}`}
        onClick={handleToggle}
        disabled={disabled}
      >
        {renderSelectedName()}
        <i className="fa fa-caret-down" aria-hidden="true"></i>
      </Button>


      {error && (
        <div className="invalid-feedback" style={{ display: error ? "block" : "none" }}>
          {error}
        </div>
      )}

      {show && (
        <div className={style.dropdownContent}>
          <input
            type="text"
            placeholder="Search.."
            className={style.searchInput}
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
          {itemsFiltered.length > 0 ? (
            itemsFiltered.map((item) => {
              return (
                <p key={getSelectedId(item)} onClick={() => handleSelect(item)}>
                  {getSelectedName(item)}
                </p>
              );
            })
          ) : (
            <p>No se encontraron resultados...</p>
          )}
        </div>
      )}
    </div>
  );
};

export default CustomDropdown;
